import React, { useState,useEffect } from 'react';
// import { BiSearch } from 'react-icons/bi';
import { AiOutlineClose } from 'react-icons/ai';
import { HiOutlineMenuAlt4 } from 'react-icons/hi';
import '../styles/navbar.css'; // Import CSS
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import logo from '../assets/new_logo.png'
function Navbar() {
  const [show, setShow] = useState(true);
  const { t, i18n } = useTranslation(); // Initialize useTranslation hook

  const handleNav = () => {
    setShow(!show);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
const [prevScrollY, setPrevScrollY] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > prevScrollY && currentScrollY > 50) {
        setVisible(false); // scrolling down
      } else {
        setVisible(true); 
      }

      setPrevScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollY]);
  return (
    <div className={`navbar ${visible ? 'navbar-visible' : 'navbar-hidden'}`} style={{ top: visible ? '0' : '-100px' }}>
      <div>
        <h1 className={show ? 'logo logo-md' : 'hidden'}><Link to="/"><img className='logosize' alt='logo' src={logo}/></Link></h1>
      </div>

      <ul className="menu menu-md">
        <li><Link to="/">{t('home')}</Link></li>
        <li><Link to="/spice">{t('spices')}</Link></li>
        <li><Link to="/quality">{t('quality_assurance')}</Link></li>
        <li><Link to="/contact">{t('contact_us')}</Link></li>
      </ul>

      
      <div className="language-selector">
  <select onChange={(e) => changeLanguage(e.target.value)} defaultValue={i18n.language}>
    <option value="en">en</option>

    <option value="es">es</option>
    <option value="fr">fr</option>
    <option value="de">de</option>
    <option value="nl">nl</option>
    <option value="it">it</option>
    <option value="pl">pl</option>
  </select>
</div>

      

      <div onClick={handleNav} className="mobile-icon">
        {show ? <HiOutlineMenuAlt4 size={20} /> : <AiOutlineClose className='close' size={20} />}
      </div>

      <div className={!show ? 'mobile-menu' : 'mobile-hidden'}>
        <h1 className="logo logo-md">Nicez</h1>
        <li><Link onClick={handleNav} to="/">{t('home')}</Link></li>
        <li><Link onClick={handleNav} to="/spice">{t('spices')}</Link></li>
        <li><Link onClick={handleNav} to="/quality">{t('quality_assurance')}</Link></li>
        <li><Link onClick={handleNav} to="/contact">{t('contact_us')}</Link></li>
        {/* Language Selector for mobile menu */}
        <div className="mobile-language-selector">
  <select onChange={(e) => { changeLanguage(e.target.value); handleNav(); }} defaultValue={i18n.language}>
     <option value="en">en</option>

    <option value="es">es</option>
    <option value="fr">fr</option>
    <option value="de">de</option>
    <option value="nl">nl</option>
    <option value="it">it</option>
    <option value="pl">pl</option>
  </select>
</div>

      </div>
    </div>
  );
}

export default Navbar;